
import { OrderItemFulfillmentStatusEnum } from "app/back-office/shared/enum/order-item-fulfillment-status.enum";
import { ChannelDiscountDTO } from "app/back-office/shared/models/back-office-admin-common/channel-discount.model";
import { AppliedAutomaticDiscount } from "app/back-office/shared/models/back-office-admin-common/applied-automatic-discount.models";
import { AppliedManualDiscount } from "app/back-office/shared/models/back-office-admin-common/applied-manual-discount.model";
import { ProductVariant } from "app/shop/shared/models/product-variant";
import { OrderItemDeliveryDTO } from "./custom-deliveries.models";
import { GeneralFieldsDTO } from "app/back-office/shared/models/customer/customer.model";

export class OrderItem {
  id: number;
  quantity: number;
  note: string;
  internalNote: string;
  requestedDeliveryDate: string;
  code: string;
  variant: ProductVariant;
  variantId: number;
  storeChannelDiscount: ChannelDiscountDTO;
  discountedUnitPrice: number;
  unitPriceWholesale: number;
  unitPriceRetail: number;

  totalRetailPrice: number;
  totalWholesalePrice: number;

  // externalId: string;
  amount: number;
  alreadyFulfilledQuantity?: number;

  //TODO campi nuovi erp

  // erpCancelledQuantity: number;
  // erpDeliveryDate: string;
  erpDiscountedTotalPrice: number;
  erpDiscountedUnitPrice: number;
  erpFulfilledQuantity: number;
  erpFulfilledTotalPrice: number;
  // erpQuantity: number;
  erpQuantityPendingFulfillment: number;
  erpTotalRetailPrice: number;
  fulfillmentStatus: OrderItemFulfillmentStatusEnum;

  appliedAutomaticDiscounts: AppliedAutomaticDiscount[];
  appliedManualDiscounts: AppliedManualDiscount[];
  agreementDiscountDeductedUnitPriceAmount: number;
  agreementDiscountPercentage: number;
  automaticDiscountsDeductedUnitPriceAmount: number;
  automaticDiscountsMergedPercentage: number;
  customerDiscountDeductedUnitPriceAmount: number;
  customerDiscountPercentage: number;
  cancellationReason: GeneralFieldsDTO;
  cancellationReasonId: number;
  discountedUnitPriceAfterAgreementDiscount: number;
  discountedUnitPriceAfterAutomaticDiscounts: number;
  discountedUnitPriceAfterCustomerDiscount: number;
  discountedUnitPriceAfterStoreChannelDiscount: number;
  manualDiscountsDeductedUnitPriceAmount: number;
  manualDiscountsMergedPercentage: number;
  storeChannelDiscountDeductedUnitPriceAmount: number;
  storeChannelDiscountPercentage: number;
  deliveries: OrderItemDeliveryDTO[];

  constructor(s: Partial<OrderItem>) {
    Object.assign(this, s);
    this.variant = new ProductVariant(this.variant);
  }
}

export class OrderItemsBulkRequestBody {
  orderItemsToUpdate?: OrderItemBulkUpdateItem[];
  orderItemsToInsert?: OrderItemBulkInsertItem[];
  orderItemIdsToRemove?: number[];
  constructor(init?: OrderItemsBulkRequestBody) {
    Object.assign(this, init);
    if (!this.orderItemsToUpdate) this.orderItemsToUpdate = [];
    if (!this.orderItemsToInsert) this.orderItemsToInsert = [];
    if (!this.orderItemIdsToRemove) this.orderItemIdsToRemove = [];
  }
}

export class OrderItemsBulkResponseBody {
  insertedOrderItems?: { orderItemId: number, variantId: number }[];
  updatedOrderItems?: { orderItemId: number, variantId: number }[];
  constructor(init?: OrderItemsBulkRequestBody) {
    Object.assign(this, init);
    if (!this.insertedOrderItems) this.insertedOrderItems = [];
    if (!this.updatedOrderItems) this.updatedOrderItems = [];
  }
}

/**
 * `discountPercentage` e `requestedUnitPrice` sono lo sconto commerciale della riga e sono mutuamente
 * esclusivi: valorizzarli entrambi fa rispondere 400. Su questo endpoint ometterli entrambi è invece
 * legittimo (riga senza sconto commerciale). Dove l'utente digita un prezzo si manda quello, non la
 * percentuale: convertire perde i centesimi.
 */
export class OrderItemBulkUpdateItem {
  id: number;
  quantity: number;
  alreadyFulfilledQuantity?: number;
  note?: string;
  internalNote?: string;
  requestedDeliveryDate: string;
  discountPercentage?: number;
  requestedUnitPrice?: number;
  constructor(init?: OrderItemBulkUpdateItem) {
    Object.assign(this, init);
  }
}

/** Vedi {@link OrderItemBulkUpdateItem} per l'esclusività fra `discountPercentage` e `requestedUnitPrice`. */
export class OrderItemBulkInsertItem {
  variantId: number;
  quantity: number;
  note: string;
  internalNote: string;
  requestedDeliveryDate: string;
  discountPercentage?: number;
  requestedUnitPrice?: number;
  constructor(init?: OrderItemBulkInsertItem) {
    Object.assign(this, init);
  }
}


